export default "__VITE_ASSET__ab54b00a__"